import React from "react";
import DataTable from "../../components/DataTable";

const dataJson = [
  {
    id: "4347348",
    date: "01/03/2022",
    amount: "$45",
    remarks: "78",
  },
  {
    id: "7fd88fd",
    date: "01/03/2022",
    amount: "$45",
    remarks: "78",
  },
  {
    id: "dfd5fs5",
    date: "01/03/2022",
    amount: "$45",
    remarks: "78",
  },
  {
    id: "fe7s4f",
    date: "01/03/2022",
    amount: "$45",
    remarks: "78",
  },
];

const columns = [
  { id: "date", label: "Date", minWidth: 80 },
  { id: "amount", label: "Amount", minWidth: 50 },
  {
    id: "remarks",
    label: "Remarks",
    minWidth: 50,
  },
];

function createData(date, amount, remarks) {
  return { date, amount, remarks };
}

const rows = dataJson.map((d) => createData(d.date, d.amount, d.remarks));

const AutoPoolTable = () => {
  return <DataTable columns={columns} rows={rows} perPageShow={5} tableHeight={440} className="common_table" />;
};

export default AutoPoolTable;
